import React from "react";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Col from "../WrapperComponents/Col";
import Row from "../WrapperComponents/Row";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";

const CreateNewNetwork = (props) => {
  const { createNewNetworkData, group } = props;
  return (
    <div>
      <Row>
        <Col>
          <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              createNewNetworkData.nazMreze.length < 1 &&
              "red"
            }
            disabled={props.disabled}
            onChange={props.userInputHandler}
            objData={{ group: group }}
            value={createNewNetworkData.nazMreze}
            id="naziv-mreze-create-new-network"
            controlLabel={"Naziv mreže"}
            name="nazMreze"
          />
        </Col>
        <Col>
          {props.showWeb && (
            <InputComponent
              disabled={props.disabled}
              onChange={props.userInputHandler}
              objData={{ group: group }}
              value={createNewNetworkData.web}
              id="web-create-new-network"
              controlLabel={"Mjesto gdje su informacije dustupne javnosti"}
              name="web"
            />
          )}
        </Col>
      </Row>
      <BasicAddressData
        disabled={props.disabled}
        required
        hackId="create-new-network-data"
        requiredBrPoste
        requiredKbr
        requiredNazNaselja
        objData={{ group: group }}
        onChange={props.userInputHandler}
        address={createNewNetworkData}
        {...props}
      />
      {!props.disabled && (
        <Row>
          <Col></Col>
          <Col>
            {props.update ? (
              <ButtonComponent
                block
                onClick={props.updateNetworkHandler}
                loading={props.parentState.loader}
              >
                Ažuriraj
              </ButtonComponent>
            ) : (
              <ButtonComponent
                block
                onClick={props.createNewNetworkSubmitHandler}
                loading={props.parentState.loader}
              >
                Kreiraj
              </ButtonComponent>
            )}
          </Col>
          <Col></Col>
        </Row>
      )}
    </div>
  );
};

export default CreateNewNetwork;
